// extracted by mini-css-extract-plugin
module.exports = {"brandGrid":"brand-grid_brandGrid__1XRzt","hasBanner":"brand-grid_hasBanner__1PZxc"};